module.exports = __webpack_public_path__ + "static/media/xpg.3bcc8c0d.jpg";